// import { useAppSelector } from "@app/hooks";
import { APIPostFolder, BackendFolder, FolderApiResponse } from "@dataRoomSetup/models";
// import { FetchDocumentsRequestBody } from "@documents/models/api.models";
// import { impersonationStateSelector } from "@impersonateUser/store/selectors";
import { AppThunkAPI } from "@shared/models/redux";
import { RequestConfig } from "@shared/models/request";
// import { RequestConfig } from "@shared/models/request";
// import { userSliceSelector } from "@user/store/selectors";

type PostFoldersAPI = (
  id: number,
  entitledUserId: string,
  body?: APIPostFolder[],
  options?: RequestConfig<FolderApiResponse>
) => AppThunkAPI<Promise<BackendFolder[]>>;

export const postDataroomsetFolders: PostFoldersAPI =
  (id, entitledUserId, body, options) => async (_dispatch, _state, extra) => {
    const response = await extra<FolderApiResponse>(`/documents/v1/CustomDataroom/postFolder/${entitledUserId}/${id}`, {
      ...options,
      method: "post",
      body: { resources: body },
    });

    if (response.status === 204) {
      // return { total: 0, results: [] };
    }

    return response.data.resources;
  };
